import { Component, OnInit } from '@angular/core';
import { loginModel } from './shared/models/loginModel';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserManagementService } from './shared/services/user-management.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  loginModel:loginModel;
  loginResult : any;
  LoginToken : any;

  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
 

  constructor(private UserManagementService:UserManagementService, private route:Router) { }

  ngOnInit() {
    if(this.UserManagementService.isLoggedIn()){
      this.route.navigate(['/Order']);
    }
    this.resetLoginForm();
  }

  resetLoginForm(){
    this.loginModel =
    {
      Username :'',
      Password : '',
      }    
  }

  login(){
    debugger;
    if((!this.loginModel.Username || this.loginModel.Username === '') || (!this.loginModel.Password || this.loginModel.Password === '')){
      return;
    }
      this.UserManagementService.login(this.loginModel).subscribe(response => {
        if(response){
          this.loginResult = response;
         // console.log(response);
          
          // this.UserManagementService.LoginToken = this.loginResult.Token;
          // console.log( this.UserManagementService.LoginToken);

           this.UserManagementService.LoginUserName = this.loginResult.Username;
           this.route.navigate(['/Order']);
          // console.log(this.UserManagementService.LoginUserName);
        }
        
      });  
  }

  logout(){
    this.UserManagementService.logout();
  }

}
      
  

